import React, { useState } from 'react';
import { DI, DIProps } from '../../../../Core';
import { ActionList, BlockStack, Button, Popover, Text, Tooltip } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import RemoveBgModalBulk from './RemoveBGModal';
import { WandMinor } from '@shopify/polaris-icons';
import { GridApis } from '../Utilities/Apis';

interface props extends DIProps {
    type: string
    inProgress: any
    currentStep: any
    popover: boolean
    setpopover: (val: boolean) => void
    activator: any
    setactiontype: (payload: any) => void
    setsyncModal: (val: boolean) => void
    setLoading: (val: boolean) => void
    setCurrentStep: (val: any) => void
    activityRefreshAction: () => void
    // setLDModal: (payload: any) => void
    selectedRows: string[]
    setselectedRows: (image: any) => void
    setOpenModal: (e: any) => void;
    setdeleteModal: (e: any) => void;
    setSelectOpt: (data: any) => any;
    templateNew: (data: any) => void;

}

const ActionPopOver = (props: props) => {
    const { t } = useTranslation();
    const [bgModalOpen, setBgModalOpen] = useState(false);
    const { type, inProgress, currentStep, popover, activityRefreshAction, activator, setpopover, setactiontype, setsyncModal, setLoading, setCurrentStep,
        // setLDModal,
        selectedRows, setselectedRows, templateNew } = props;
    const [templateOption, settemplateOption] = useState<any>({});
    function handleTemplate() {
        props.setOpenModal(true)
        props.di
            .GET(
                `${GridApis.getProfileData}?all_profile_name=true&sort_order=desc`
            )
            .then((response) => {
                if (response.success) {
                    let tempData: any = [];
                    let tempData2: any = [];
                    let temp2: any = [];
                    let obj: any = {};
                    response?.projectData?.forEach((profile: any) => {
                        tempData.push({
                            label: profile?.['name'],
                            value: profile?.['_id']?.['$oid'],
                        });

                        if (profile?.type === 'manual') {
                            let profName = profile?.['_id']?.['$oid'];
                            obj = {
                                [profName]: profile?.manual_product_ids,
                            };
                            temp2.push(obj);
                            tempData2.push({
                                label: profile?.['name'],
                                value: profile?.['_id']?.['$oid'],
                            });
                        }
                    });
                    if (tempData2) {
                        settemplateOption(tempData2);
                        templateNew(tempData2)
                    }
                } else {
                    console.error(response.message);
                }
            });
    }

    function deleteTemplate() {
        props.setdeleteModal(true)
    }
    return (
        <>
            <RemoveBgModalBulk {...props} activityRefreshAction={activityRefreshAction} selectedRows={selectedRows} setselectedRows={setselectedRows} setBgModalOpen={setBgModalOpen} bgModalOpen={bgModalOpen} isSingleEdit={false} />
            <Popover
                active={type === 'ParentRow' ? (inProgress && (currentStep === 6 || currentStep === 2)) || popover : (inProgress && currentStep === 6) || popover}
                activator={activator}
                sectioned={true}
                onClose={() => setpopover(false)}
            >
                <Popover.Pane>
                    {props.di.globalState.get(
                        'admin_login',
                        true
                    ) && <Popover.Section>
                            <div className='custom-ai-icon'>
                                <Button
                                    size="slim"
                                    id="amazonUpload"
                                    removeUnderline
                                    icon={WandMinor}
                                    variant="monochromePlain" onClick={() => setBgModalOpen(true)}>
                                    Remove Image Background
                                </Button>
                            </div>
                        </Popover.Section>}
                    <Popover.Section>
                        <Button
                            size="slim"
                            id="amazonUpload"
                            removeUnderline
                            onClick={() => {
                                setactiontype({
                                    title: t('Upload Product'),
                                    key: 'Upload Product',
                                    description: t('Are you sure you want to upload the selected products on Amazon?'),
                                    actionName: t('Confirm'),
                                });
                                setsyncModal(true);
                                inProgress && setCurrentStep((a: any) => +a + 1);
                                setLoading(true);
                                const interval = setInterval(() => setLoading(false), 500);
                                return () => clearInterval(interval);
                            }}
                            variant="monochromePlain">
                            {t("Upload Product(s)")}
                        </Button>
                    </Popover.Section>

                    <Popover.Section>
                        <Button
                            size="slim"
                            removeUnderline
                            onClick={() => {
                                setactiontype({
                                    title: t('Sync Product'),
                                    key: 'Sync Product',
                                    description: t('Do you want to Sync the selected products with Amazon?'),
                                    actionName: t('Confirm'),
                                });
                                setsyncModal(true);
                            }}
                            variant="monochromePlain">
                            {t("Sync Product(s)")}
                        </Button>
                    </Popover.Section>

                    <Popover.Section>
                        <Tooltip
                            preferredPosition="mostSpace"
                            content={
                                <BlockStack gap="100" align="space-between">
                                    <Text as="p">{t("Previously known as 'Search on Amazon'.")}</Text>
                                    <Text as="p">{t("This functionality checks if your Products' barcodes are unique or if they are already available on Amazon. If the barcode is already available, then the product is eligible for offer listing and its status will change from 'Not Listed' to 'Not Listed:Offer'.")}</Text>
                                </BlockStack>
                            }
                            dismissOnMouseOut>
                            <Button
                                size="slim"
                                id="amazonLookup"
                                removeUnderline
                                onClick={() => {
                                    setactiontype({
                                        title: t('Amazon Lookup'),
                                        key: 'Amazon Lookup',
                                        description: t('You can choose to run Amazon Lookup for any number of products you want. This will update the status of those products that are currently under “Not Listed: Offer” status.'),
                                        actionName: t('Proceed'),
                                    });
                                    setsyncModal(true);
                                    inProgress && setCurrentStep((a: any) => +a + 1);
                                    setLoading(true);
                                    const interval = setInterval(() => {
                                        setLoading(false);
                                    }, 500);
                                    return () => clearInterval(interval);
                                }}
                                variant="monochromePlain">
                                {t("Amazon Lookup")}
                            </Button>
                        </Tooltip>
                    </Popover.Section>
                    <Popover.Section>
                        <ActionList
                            actionRole="menuitem"
                            items={[
                                {
                                    content: t('Sync Inventory'),
                                    onAction: () => {
                                        setactiontype({
                                            title: t('Sync Inventory'),
                                            key: 'Sync Inventory',
                                            description: t('Do you want to synchronize the inventory for the selected products on Amazon?'),
                                            actionName: t('Confirm'),
                                        });
                                        setsyncModal(true);
                                    }
                                },
                                {
                                    content: t('Sync Price'),
                                    onAction: () => {
                                        setactiontype({
                                            title: t('Sync Price'),
                                            key: 'Sync Price',
                                            description: t('Do you want to synchronize the price for the selected products on Amazon?'),
                                            actionName: t('Confirm'),
                                        });
                                        setsyncModal(true);
                                    }
                                },
                                {
                                    content: t('Sync Image'),
                                    onAction: () => {
                                        setactiontype({
                                            title: t('Sync Image'),
                                            key: 'Sync Image',
                                            description: t('Do you want to synchronize the image for the selected products on Amazon?'),
                                            actionName: t('Confirm'),
                                        });
                                        setsyncModal(true);
                                    }
                                },
                            ]}
                        />
                    </Popover.Section>
                </Popover.Pane>
                {props?.type == "parentRow" && <>
                    <Popover.Pane fixed>
                        <Popover.Section>
                            <Button
                                size="slim"
                                onClick={() => {
                                    handleTemplate()
                                }}
                                variant="monochromePlain">
                                {t("Assign Template")}
                            </Button>
                        </Popover.Section>
                    </Popover.Pane>

                    <Popover.Pane fixed >
                        <Popover.Section>
                            <Button
                                size="slim"
                                onClick={() => {
                                    deleteTemplate()
                                }}
                                variant="monochromePlain">
                                {("Unassign Template")}
                            </Button>
                        </Popover.Section>
                    </Popover.Pane></>}
                    <Popover.Pane fixed>
                        <Popover.Section>
                            <Button
                                size="slim"
                                removeUnderline
                                onClick={() => {
                                    setactiontype({
                                        title: t('Delete Product'),
                                        key: 'Delete Product',
                                        description: t('Are you sure you want to delete the selected products?'),
                                        actionName: t('Delete'),
                                    });
                                    setsyncModal(true);
                                }}
                                variant="plain"
                                tone="critical">
                                {t("Delete Products")}
                            </Button>
                        </Popover.Section>
                    </Popover.Pane>
                </Popover>
            </>
            )
}

            export default DI(ActionPopOver)